<template>
  <div>
    schema:{{ schema }}
    <component
      :is="schema['x-display'] || 'v-text-field'"
      v-model="valueProxy"
      :rules="rules"
      :type="schema['x-type'] || 'text'"
      :outlined="schema.outlined"
      :label="label"
      :class="customClass"
      :style="customStyle"
      v-bind="getVBind(schema)"
      :readonly="getReadOnly()"
      @input="onInput"
      @change="onChange"
      @click:append="onAppendClick"
      @click:clear="onClear"
    />
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import draggable from "vuedraggable";
import debounce from "lodash/debounce";
export default {
  components: {
    draggable,
    VFormComponent: () => import("./FormComponent.vue"),
    VAddress: () => import("./Address.vue"),
    VDateField: () => import("./DateField.vue"),
    VTimeField: () => import("./TimeField.vue"),
    VDateTime: () => import("./DateTime.vue"),
    VCombo: () => import("./ComboBox.vue"),
    VAddButton: () => import("./AddButton.vue"),
    VDeleteButton: () => import("./DeleteButton.vue"),
    VMoveButton: () => import("./MoveButton.vue"),
    AddToTable: () => import("./AddToTable.vue"),
    VAccordion: () => import("./Accordion.vue"),
    VLabelButton: () => import("./LabelButton.vue"),
    VLabel: () => import("./Label.vue"),
    DList: () => import("../components/List.vue"),
    DIterator: () => import("../components/Iterator.vue"),
    DTable: () => import("../components/Table.vue"),
    VDateRangePicker: () => import("../components/DateRangePicker.vue"),
    USMap: () => import("../components/USMap.vue"),
    VRadioList: () => import("../components/RadioList.vue"),
    VCheckboxList: () => import("../components/CheckBoxList.vue"),
    VPanels: () => import("../components/Panels.vue"),
    VUnitCharge: () => import("../components/UnitCharge.vue"),
    VTreeInput: () => import("../components/TreeInput.vue"),
    VSelectedReportFields: () =>
      import("../components/SelectedReportFields.vue"),
    VEditor: () => import("../components/Editor.vue"),
    SendLetter: () => import("../components/SendLetter.vue"),
    WeekDays: () => import("../components/WeekDays.vue"),
    DaysOfMonth: () => import("../components/DaysOfMonth.vue"),
    VRate: () => import("../components/Rate.vue"),
    VLabor: () => import("../components/Labor.vue"),
    VColorField: () => import("../components/ColorField.vue"),
    VCollapsible: () => import("../components/Collapsible.vue"),
    VPresetTable: () => import("../components/PresetTable.vue"),
    VUpload: () => import("../components/UploadDragDrop.vue"),
    VLinkedObject: () => import("./LinkedObject.vue"),
    VAvailabilitySearch: () => import("../components/AvailabilitySearch.vue"),
    VImage: () => import("../components/Image.vue"),
    VMenuButton: () => import("../components/MenuButton.vue"),
    VDocument: () => import("../components/Document.vue"),
    VFormToolBar: () => import("../components/FormToolBar.vue"),
    VDialogTable: () => import("../components/DialogTable.vue"),
    VDataTimeLine: () => import("../components/DataTimeLine.vue"),
    VRange: () => import("../components/Range.vue"),
    VCc: () => import("../components/CC.vue"),
    vAchBank: () => import("../components/AchBank.vue"),
    VCrew: () => import("../components/Crew.vue"),
    VLinkInput: () => import("../components/LinkInput.vue"),
    VAvailability: () => import("../components/Availability.vue"),
    VTakePhoto: () => import("../components/TakePhoto.vue"),
    VArray: () => import("../components/Array.vue"),
    VPhone: () => import("../components/Phone.vue"),
    VLetterBody: () => import("../components/LetterBody.vue"),
    VSmsBody: () => import("../components/SMSBody.vue"),
    VCustomerInventory: () =>
      import("../components/dashboard/CustomerInventory.vue"),
    VDragDropList: () => import("../components/DragDropList.vue"),
    VSmartField: () => import("../components/SmartField.vue"),
  },
  props: {
    schema: Object,
    value: null,
    keyName: String,
    model: Object,
    rules: Array,
    getRule: Function,
    calculateTitle: Function,
    getInput: Function,
    onValueChange: Function,
    placeholder: String,
    additionalModel: Object,
    parentModel: Object,
    parentSchema: Object,
    parentKey: String,
    parModel: Object,
    parObject: Object,
    parentObject: Object,
    data_object: Object,
    inLine: Boolean,
    changeTab: Function,
  },
  computed: {
    valueProxy: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    label() {
      if (this.schema.hideTitle) return "";
      if (this.schema.calculatedTitle && this.calculateTitle) {
        return this.calculateTitle(this.schema.calculatedTitle, this.keyName);
      }
      return this.schema.title;
    },
    customClass() {
      const value = this.schema;
      if (value.class) return value.class;
      if (
        ["d-table", "v-data-time-line", "d-iterator"].includes(
          value["x-display"]
        )
      ) {
        return this.$vuetify.breakpoint.smAndDown ? "ml-0" : "ml-0 mr-n4 pa-0";
      }
      if (value["x-display"] === "v-switch") return "mt-5";
      return "pl-2 mr-6";
    },
    customStyle() {
      const value = this.schema;
      if (value["full-width"] !== false) {
        return value.description
          ? "width:60% !important"
          : "width:100% !important";
      }
      if (
        ["v-date-field", "v-time-field", "v-datetime-picker"].includes(
          value["x-display"]
        )
      ) {
        return "200px !important";
      }
      if (
        !["v-address", "v-accordion"].includes(value["x-display"]) &&
        value["full-width"] !== true
      ) {
        return !value.hideTitle
          ? "max-width:240px !important"
          : "max-width:240px !important; margin-top:-18px !important";
      }
      return this.$vuetify.breakpoint.mdAndUp ? "max-width:95%" : "";
    },
  },
  methods: {
    getVBind(val) {
      return val["v-bind"] || {};
    },
    getReadOnly() {
      if (
        this.schema?.["v-bind"]?.readonly ||
        this.schema?.["v-bind"]?.readOnlyFormula
      ) {
        try {
          return eval(this.schema["v-bind"].readOnlyFormula);
        } catch (e) {
          return this.schema["v-bind"].readonly || false;
        }
      }
      return false;
    },
    onInput(val) {
      this.getInput?.(this.keyName, this.schema?.onValueChange, "input");
    },
    onChange(val) {
      this.getInput?.(this.keyName, this.schema?.onValueChange, "change");
    },
    onClear() {
      this.getInput?.(this.keyName, this.schema?.onValueChange, "clear");
    },
    onAppendClick() {
      this.getInput?.(
        this.keyName,
        this.schema?.["v-bind"]?.onAppendClick,
        "appendClick"
      );
    },
  },
};
</script>
